import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core'
import { AgendaItemCategory, AgendaNode, AgendaItemSubCategory } from '../../calls.service'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { FormsModule } from '@angular/forms'
import { MatOption } from '@angular/material/autocomplete'
import { MatSelect } from '@angular/material/select'
import { CdkTrapFocus } from '@angular/cdk/a11y'

@Component({
  selector: 'app-agenda-editor-item',
  standalone: true,
  imports: [TranslatePipe, FormsModule, MatOption, MatSelect, CdkTrapFocus],
  templateUrl: './agenda-editor-item.component.html',
  styleUrl: './agenda-editor-item.component.scss',
})
export class AgendaEditorItemComponent implements OnInit {
  @Input({ required: true })
  node!: AgendaNode

  @Input({ required: true })
  activeItemId!: number | null

  @Input()
  isReadonly: boolean = false

  @Output()
  setAsActive = new EventEmitter<number>()

  @Output()
  updateNode = new EventEmitter<AgendaNode>()

  @ViewChild('categoryMatSelect', { read: MatSelect })
  categoryMatSelect!: MatSelect

  @ViewChild('subCategoriesMatSelect', { read: MatSelect })
  subCategoriesMatSelect!: MatSelect

  translateService = inject(TranslateService)

  isEditingItemNumber = false
  isEditingTitle = false
  isEditingPresenters = false
  isEditingCategory = false
  isEditingSubCategories = false
  itemNumber!: string | null
  title!: string
  presenters!: string
  category!: AgendaItemCategory
  subCategories!: AgendaItemSubCategory[]

  get isEditing(): boolean {
    return this.isEditingItemNumber || this.isEditingTitle || this.isEditingPresenters || this.isEditingCategory || this.isEditingSubCategories
  }

  get hasChildren(): boolean {
    return this.node.subitems.length > 0
  }

  ngOnInit(): void {
    this.itemNumber = this.node.itemNumber
    this.title = this.node.title
    this.presenters = this.node.presenters
    this.category = this.node.category
    this.subCategories = this.node.subCategories
  }

  saveItemNumber() {
    this.isEditingItemNumber = false
    this.node.itemNumber = this.itemNumber
    this.updateNode.emit(this.node)
  }

  saveTitle() {
    this.isEditingTitle = false
    this.node.title = this.title
    this.updateNode.emit(this.node)
  }

  savePresenters() {
    this.isEditingPresenters = false
    this.node.presenters = this.presenters
    this.updateNode.emit(this.node)
  }

  saveCategory(value: AgendaItemCategory) {
    this.category = value
    this.isEditingCategory = false
    this.isEditingCategory = false
    this.node.category = this.category
    this.node.subCategories = []
    this.updateNode.emit(this.node)
  }

  saveSubCategories() {
    this.isEditingSubCategories = false
    this.node.subCategories = this.subCategories
    this.updateNode.emit(this.node)
  }

  handleItemNumberLabelClick() {
    if (this.isReadonly) {
      return
    }
    this.isEditingItemNumber = true
  }

  handleTitleLabelClick() {
    if (this.isReadonly) {
      return
    }
    this.isEditingTitle = true
  }

  handlePresentersLabelClick() {
    if (this.isReadonly) {
      return
    }
    this.isEditingPresenters = true
  }

  handleCategoryLabelClick() {
    if (this.isReadonly) {
      return
    }
    this.isEditingCategory = true
    setTimeout(() => {
      if (!this.categoryMatSelect) {
        return
      }
      this.categoryMatSelect.open()
    })
  }

  handleSubCategoriesLabelClick() {
    if (this.isReadonly) {
      return
    }
    this.isEditingSubCategories = true
    setTimeout(() => {
      if (!this.subCategoriesMatSelect) {
        return
      }
      this.subCategoriesMatSelect.open()
    })
  }
}
